import React, { memo, forwardRef } from 'react';
import cn from 'classnames';

import styles from './TextArea.module.scss';

export interface TextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  /** Custom class name */
  textAreaClassName?: string;
  /** Custom style */
  textAreaStyle?: Record<string, unknown>;
  /** What is the label for the textarea element? */
  label?: string;
  /** Is input field valid? */
  isValid?: boolean;
  /** What is the error message? */
  helperText?: string;
}

export const TextArea = memo(
  forwardRef<HTMLTextAreaElement, TextAreaProps>(
    (
      {
        className = '', // custom class name
        style, // custom style
        textAreaStyle,
        textAreaClassName,
        label,
        id,
        isValid,
        helperText,
        ...props
      },
      ref
    ) => {
      const contentClassNames = cn(styles.TextArea, className, {
        [styles.TextAreaIsInvalid]: !isValid,
      });

      return (
        <section
          className={contentClassNames}
          style={style}
          data-testid="TextAreaContainer"
        >
          <div className={styles.TextAreaLabel}>
            {label ? (
              <label htmlFor={id}>
                <span></span>
                {label}
              </label>
            ) : null}
            {helperText ? (
              <label htmlFor={id} className={styles.TextAreaHelperText}>
                {helperText}
              </label>
            ) : null}
          </div>
          <textarea
            id={id}
            ref={ref}
            data-testid="TextArea"
            aria-invalid={!isValid}
            style={textAreaStyle}
            className={cn(styles.TextAreaElement, textAreaClassName)}
            {...props}
          ></textarea>
        </section>
      );
    }
  )
);

TextArea.displayName = 'TextArea';
